import QuestionValue from "./QuestionValue";

export default class QuestionValueMeasurementLabel extends QuestionValue{
    constructor(value, texture, tag) {
		super(value);

		this._texture = texture;
		this._tag = tag;
	}

	get texture() {
		return this._texture;
	}

	get tag(){
    	return this._tag;
	}
}